/**
 * @file Component barrel + registration.
 *
 * Registering every component in one place, in a fixed order, makes the bit
 * assignment deterministic across reloads — which matters because query masks
 * are cached by their numeric value.
 *
 * ADDING A COMPONENT: create the class, export it here, append it to the
 * `registerComponents` call. Never insert into the middle of the list.
 */

import { registerComponents } from '../ecs/Component.js';

import { Transform } from './Transform.js';
import { Velocity } from './Velocity.js';
import { Health } from './Health.js';
import { Weapon, FireResult, WeaponState, ShotType, FireMode } from './Weapon.js';
import { Collider } from './Collider.js';
import { Renderable } from './Renderable.js';
import { PlayerControlled } from './PlayerControlled.js';
import { AIBrain, AIState, IDLE_STATES } from './AIBrain.js';
import { Projectile } from './Projectile.js';
import { Lifetime } from './Lifetime.js';
import { StatusEffects, TimedStatus, statMultiplier, timedStatusRemaining } from './StatusEffects.js';
import { Pickup } from './Pickup.js';
import { Explosive } from './Explosive.js';
import { ExplosiveTrigger } from './ExplosiveTrigger.js';
import { Trail } from './Trail.js';
import { Destructible } from './Destructible.js';
import { RangedAI, RangedState } from './RangedAI.js';
import { VisualIndicator, IndicatorKind } from './VisualIndicator.js';
import { ThrownWeapon } from './ThrownWeapon.js';
import { InteractionTarget } from './InteractionTarget.js';
import { Burn } from './Burn.js';
import { Chest } from './Chest.js';

registerComponents(
  Transform,
  Velocity,
  Health,
  Weapon,
  Collider,
  Renderable,
  PlayerControlled,
  AIBrain,
  Projectile,
  Lifetime,
  StatusEffects,
  Pickup,
  Explosive,
  Trail,
  Destructible,
  ExplosiveTrigger,
  RangedAI,
  VisualIndicator,
  ThrownWeapon,
  InteractionTarget,
  Burn,
  Chest
);

export {
  Transform,
  Velocity,
  Health,
  Weapon,
  FireResult,
  WeaponState,
  ShotType,
  FireMode,
  Collider,
  Renderable,
  PlayerControlled,
  AIBrain,
  AIState,
  IDLE_STATES,
  Projectile,
  Lifetime,
  StatusEffects,
  TimedStatus,
  statMultiplier,
  timedStatusRemaining,
  Pickup,
  Explosive,
  Trail,
  Destructible,
  ExplosiveTrigger,
  RangedAI,
  RangedState,
  VisualIndicator,
  IndicatorKind,
  ThrownWeapon,
  InteractionTarget,
  Burn,
  Chest
};
